/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import CourseButton from './CourseButton'
import CodeInput from './CodeInput'
import { Typography } from 'components'
import ErrorBoundary from 'components/errorBoundary'
import { useWindowSize } from 'react-use'
import { getPrice } from 'utils/utils'
import { useVisibility } from 'utils/useVisibility'
import Footer from './Footer'
import purchasedIcon from 'images/purchased-white.svg'

const Container = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: grid;
  /* grid-template-columns: 25% 75%; */
  grid-row-gap: 15px;

  @media (max-width: 1024px) {
    grid-template-columns: 30% 70%;
  }
  @media (max-width: 900px) {
    grid-template-columns: 35% 65%;
  }
  @media (max-width: 425px) {
    margin-bottom: 18px;
  }
`
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`
const ButtonWrapper = styled.div`
  width: 100%;
`
// const PriceGroup = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   gap: 2px;
//   margin-top: 2px;

//   @media (max-width: 425px) {
//     margin-top: 0px;
//   }
// `
const PurchasedRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-end;
`
const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
`
const CustomA = styled.a`
  font-size: 14px;
  color: ${(props) => props.theme['sa-blue']};

  :hover {
    text-decoration: underline;
    color: ${(props) => props.theme['sa-blue']};
  }

  @media (max-width: 425px) {
    font-size: 12px;
  }
`

const Price = ({ enrolledStatus, totalPrice, locale, isFooter }) => {
  const isTh = locale === 'th'
  const { width } = useWindowSize()
  const displayPrice = (price) => {
    if (price === 0) {
      return isTh ? 'ฟรี' : 'Free'
    }
    if (price > 0) {
      return getPrice(price)
    }
    return isTh ? 'ใช้โค้ดเท่านั้น' : 'Use Code Only'
  }

  return (
    <Fragment>
      {enrolledStatus === 'enrolled' ? (
        <PurchasedRow>
          <Typography
            id="course.detail.purchased"
            color={isFooter ? 'primary1' : 'white'}
            fontSize={width <= 425 ? 'text-sm' : 'text-xl'}
            fontWeight={width <= 425 ? 700 : 600}
            nowrap
          >
            Purchased
          </Typography>
          <Icon src={purchasedIcon} alt="purchasedIcon" />
        </PurchasedRow>
      ) : (
        <Typography
          color={isFooter ? 'primary1' : 'white'}
          fontSize={width <= 425 ? 'text-sm' : 'text-xl'}
          fontWeight={width <= 425 ? 700 : 600}
          nowrap
        >
          {displayPrice(totalPrice)}
        </Typography>
      )}
    </Fragment>
  )
}

const EnrollSection = (props) => {
  // console.log('props', props)
  const {
    course,
    isLoading,
    inviteCode,
    enrolledStatus,
    prerequisiteResult,
    promotion,
    locale,
    onEnroll,
    handleLoginModal,
  } = props
  const isTh = locale === 'th'
  const { width } = useWindowSize()
  const packagePrice = course?.packagePrice || []
  const [isButtonVisible, buttonRef] = useVisibility(40)
  const [quantity, setQuantity] = useState({ value: 1, label: 1 })
  const [shownSelect, setShownSelect] = useState(false)
  const [shownCodeInput, setShownCodeInput] = useState(null)
  const [appliedCode, setAppliedCode] = useState('')
  const [disabled, setDisabled] = useState(false)

  const quantityOptions = packagePrice.map((item) => {
    if (isTh)
      return { label: `ลงทะเบียน 1 ครั้ง เรียนได้ ${item.quantity} ท่าน`, value: item.quantity }

    return {
      label: `1 Registration for ${item.quantity} Accounts`,
      value: item.quantity,
    }
  })

  const totalPrice =
    packagePrice.length > 0
      ? packagePrice.find((item) => item.quantity === quantity.value)?.price
      : course?.price

  const requiredPrerequisite =
    !prerequisiteResult?.isPassed && prerequisiteResult?.baseCourses?.length > 0

  useEffect(() => {
    const status =
      ((shownCodeInput && !appliedCode) || isLoading || requiredPrerequisite) &&
      enrolledStatus === 'notEnroll'
    setDisabled(status)
  }, [shownCodeInput, appliedCode, isLoading, requiredPrerequisite, enrolledStatus])

  const showPrerequisite = () => {
    const { baseCourses } = prerequisiteResult
    if (Array.isArray(baseCourses) && !!baseCourses.length)
      return !prerequisiteResult.isPassed && !!baseCourses?.length
    return false
  }

  const onShowCodeInput = () => {
    setShownSelect(false)
    setShownCodeInput(true)
    setQuantity({ value: 1, label: 1 })
  }
  const onCloseCodeInput = () => {
    setShownCodeInput(false)
    setShownSelect(true)
    setQuantity(quantityOptions[0])
  }

  useEffect(() => {
    if (packagePrice.length > 0) {
      setQuantity(quantityOptions[0])
    }
  }, [course])

  useEffect(() => {
    if (shownCodeInput !== null) {
      return
    }
    if (enrolledStatus === 'notEnroll' && packagePrice.length > 0) {
      setShownSelect(true)
    } else {
      setShownSelect(false)
    }
  }, [enrolledStatus, packagePrice, shownCodeInput])

  const PriceProps = {
    enrolledStatus,
    totalPrice,
    locale,
  }

  const courseButtonProps = {
    onEnroll: () =>
      onEnroll({
        quantity: quantity.value,
        promoCode: appliedCode,
        newPrice: quantity.value === 1 ? promotion?.newPrice : undefined,
      }),
    inviteCode: inviteCode,
    courseMode: course?.publicMode,
    enrolledStatus: disabled ? 'disabled' : enrolledStatus,
    schoolId: course?.school?.id,
    courseId: course?.id,
    courseName: course?.name,
    courseImage: course?.image,
    handleLoginModal: handleLoginModal,
  }

  const FooterProps = {
    courseButtonProps: courseButtonProps,
    schoolName: course?.school?.name,
    schoolLogo: course?.school?.logo,
    priceComponent: <Price {...PriceProps} isFooter={true} />,
  }

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      height: width <= 425 ? 37 : 60,
      backgroundColor: 'black',
      borderRadius: width <= 425 ? 8 : 10,
      border: '1px solid #FFFFFF',
      boxShadow: 'none',

      '&:hover': {
        border: '1px solid #5a69fe',
      },
      '&:active': {
        border: '1px solid #5a69fe',
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: 'white',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      svg: {
        fill: 'white',
        width: 24,
        height: 24,
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: width <= 425 ? 12 : 16,
      color: 'white',
      marginLeft: 5,
    }),
    option: (provided) => ({
      ...provided,
      fontSize: width <= 425 ? 12 : 16,
      paddingLeft: 15,
    }),
  }

  return (
    <ErrorBoundary>
      <Container>
        {/* <PriceGroup>
          <Typography id="course.detail.tuitionFee" color="primary1" fontSize="text-xs">
            Tuition Fee
          </Typography>
          <Price {...PriceProps} isFooter />
        </PriceGroup> */}
        <Wrapper>
          <ButtonWrapper ref={buttonRef}>
            <CourseButton {...courseButtonProps} />
          </ButtonWrapper>
          {showPrerequisite() && (
            <Typography color="primary1" fontSize={width <= 425 ? 'text-xs' : 'text-sm'}>
              {isTh ? 'คุณจำเป็นต้องเรียนจบ ' : 'You have to complete '}
              {prerequisiteResult?.baseCourses?.map((item, index) => (
                <Fragment key={index + ''}>
                  {index > 0 && ', '}
                  <CustomA href={`/courses/${item.slug}`} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </CustomA>
                </Fragment>
              ))}
            </Typography>
          )}
          {!inviteCode && course?.publicMode === 'CODE' && !(enrolledStatus === 'enrolled') && (
            <div>
              <Typography
                fontSize={width <= 425 ? 'text-xs' : 'text-sm'}
                id="course.private.enroll"
                color="primary1"
              >
                You will be able to enroll for this course once you receive an invite link from your
                instructor.
              </Typography>
            </div>
          )}
        </Wrapper>
        {shownSelect && <div />}
        {shownSelect && (
          <Fragment>
            <Select
              options={quantityOptions}
              value={quantity}
              styles={selectStyles}
              isSearchable={false}
              onChange={(value) => setQuantity(value)}
            />
            <div />
            <div style={{ width: '100%', textAlign: 'right' }}>
              <CustomA style={{ margin: 'auto', fontWeight: 700 }} onClick={onShowCodeInput}>
                {isTh ? 'ใช้คูปองโค้ด' : 'Use coupon code'}
              </CustomA>
            </div>
          </Fragment>
        )}
        {shownCodeInput && <div />}
        {shownCodeInput && (
          <CodeInput
            locale={locale}
            onClose={onCloseCodeInput}
            courseId={course?.id}
            totalPrice={totalPrice}
            setAppliedCode={setAppliedCode}
          />
        )}
      </Container>
      {isButtonVisible === false && <Footer {...FooterProps} />}
    </ErrorBoundary>
  )
}

export default EnrollSection
